import React from 'react';
import Select, { SingleValue } from 'react-select';
import { MdAdd } from 'react-icons/md';

import ScoreTab from 'components/common/scoreTab';

import type { FlatSelectOption } from '../types';

export interface SkillsSelectorV1Props {
  skillOptions: FlatSelectOption[];
  loading: boolean;
  onAddSkill: () => void;
  skills: Array<number | string | null>;
  ratings: Array<number | string | null | undefined>;
  rowIds: string[];
  onSkillChange: (index: number, value: number | string | undefined) => void;
  onRatingChange: (index: number, value: number | null) => void;
}

const SkillsSelectorV1: React.FC<SkillsSelectorV1Props> = ({
  skillOptions,
  loading,
  onAddSkill,
  skills,
  ratings,
  rowIds,
  onSkillChange,
  onRatingChange,
}) => {
  return (
    <>
      <div className="skills-label">
        <div className="f-left skill-label filter-label">{'Skills'}</div>
        <div className="f-right rating-label filter-label">{'Ratings'}</div>
      </div>
      {skills.map((skill, index) => {
        const rowId = rowIds[index] || `skill-row-${index}`;
        return (
          <div className="skill-select-node clearfix" key={rowId}>
            <div className="f-left skill-select">
              <Select<FlatSelectOption>
                options={skillOptions}
                isLoading={loading}
                isSearchable={true}
                isClearable={true}
                value={skillOptions.find((option) => option.value === +String(skill)) ?? null}
                onChange={(option: SingleValue<FlatSelectOption>) => {
                  const value = option?.value;
                  onSkillChange(index, value);

                  if (ratings[index] == null && value !== undefined && value !== null) {
                    onRatingChange(index, 0);
                  }
                }}
              />
            </div>
            <div className="f-right rating-select">
              <ScoreTab
                lightMode={true}
                scoreId={`resource-finder-v1-skill-${rowId}`}
                name={`resource-finder-v1-skill-${rowId}`}
                scoreValue={ratings[index] === null || ratings[index] === undefined ? null : +ratings[index]}
                handleChange={(_name: string, value: number | null) => {
                  onRatingChange(index, value);
                }}
              />
            </div>
          </div>
        );
      })}
      <div className="add-more-skill-filter-v1" onClick={onAddSkill}>
        <span className="icon-round m-auto skill-add">
          <MdAdd />
        </span>
        <span className="skill-add-label-v1">{'Add Another'}</span>
      </div>
    </>
  );
};

export default SkillsSelectorV1;
